import { useNavigate } from '@tanstack/react-router';

import { Button } from '../ui/button';

export const NotFoundComponent = () => {
  const navigate = useNavigate();
  return (
    <main
      data-testid="not-found-component"
      className="grid min-h-screen place-items-center rounded-sm border bg-white px-6 py-24 sm:py-32 lg:px-8"
    >
      <div className="text-center">
        <img
          className="mx-auto mt-4 h-[80px] w-[300px] object-contain"
          src={'/images/logos/logo.png'}
          alt="Business Logo"
        />
        <img
          className="mx-auto mt-4 h-[300px] w-[300px] object-contain"
          src={'/images/backgrounds/404.gif'}
          alt="Business Logo"
        />
        <h1 className="mt-4 text-3xl font-bold tracking-tight text-gray-900 sm:text-5xl">
          Page not found
        </h1>
        <p className="mt-6 text-base leading-7 font-light text-gray-600">
          Sorry, we couldn’t find the page you’re looking for.
        </p>
        <div className="mt-10 flex items-center justify-center gap-x-6">
          <Button onClick={() => navigate({ to: '/' })}>Go back home</Button>
          <div className="flex flex-col space-y-1 text-sm font-medium text-gray-900">
            <span aria-hidden="true">Contact support</span>
            <a href="mailto:hello@doitpay.co">
              <span className="font-light" aria-hidden="true">
                hello@doitpay.co
              </span>
            </a>
          </div>
        </div>
      </div>
    </main>
  );
};
